import { render, staticRenderFns } from "./vue_jqxvalidator.vue?vue&type=template&id=53c5d4b5"
import script from "./vue_jqxvalidator.vue?vue&type=script&lang=js"
export * from "./vue_jqxvalidator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports